module.exports = __webpack_public_path__ + "img/Objetivo 3.4371bce2.png";